import { ReactNode } from 'react';

import { FieldError } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

export function renderFieldError(
    error: FieldError | undefined
): ReactNode | undefined {
    if (!error) return undefined;

    const message = error.message as
        { id: string; defaultMessage: string } | string | undefined;

    if (!message) return undefined;

    if (typeof message === 'object' && 'id' in message) {
        return <FormattedMessage {...message} />;
    }

    return message as unknown as ReactNode;
}
